import 'vue2-dropzone/dist/vue2Dropzone.css'
import Vue from 'vue'
import App from './app/Main.vue'
import router from './router'
import store from './vuex'
import http from './http'
import ElementUI from 'element-ui'
import './assets/sass/element-variables.scss'
import ptBr from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import VueSweetAlert from 'vue-sweetalert'
import Vuelidate from 'vuelidate'
import VueScrollTo from 'vue-scrollto'
import VueMoment from 'vue-moment'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueMoney from 'v-money'
import VueTheMask from 'vue-the-mask'
import AccessControl from './plugins/access'
import VueCookie from 'vue-cookie'

import './app/filters'

Vue.use(http, {router})
Vue.use(ElementUI)
locale.use(ptBr)
Vue.use(VueSweetAlert)
Vue.use(Vuelidate)
Vue.use(VueScrollTo)
Vue.use(VueMoment)
Vue.use(VueYouTubeEmbed)
Vue.use(VueMoney)
Vue.use(VueTheMask)
Vue.use(AccessControl)
Vue.use(VueCookie)

/**
 * Create a Vue instance
 */
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js